var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { ElementRef } from '@angular/core';
import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryList } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { noop, merge } from 'rxjs';
import { UIOptionComponent } from './option.component';
import { Overlay } from 'app/ui/core/overlay';
import { OverlayRef } from 'app/ui/core/overlay-ref';
import { TemplatePortal } from 'app/ui/core/portal';
var SELECTBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return UISelectboxComponent; }),
    multi: true
};
var UISelectboxComponent = /** @class */ (function () {
    function UISelectboxComponent(_elementRef, _overlay, _viewContainerRef) {
        this._elementRef = _elementRef;
        this._overlay = _overlay;
        this._viewContainerRef = _viewContainerRef;
        this._onChange = noop;
        this._onTouched = noop;
    }
    UISelectboxComponent.prototype.ngAfterContentChecked = function () {
        var _this = this;
        if (this._optionSubscription) {
            this._optionSubscription.unsubscribe();
        }
        var emitters = merge.apply(void 0, __spread(this.options.map(function (option) { return option.onSelectOption; })));
        this._optionSubscription = emitters.subscribe(function (option) { return _this._onSelect(option); });
    };
    UISelectboxComponent.prototype.ngOnDestroy = function () {
        this._destroyOptions();
        this._destroyOverlay();
    };
    UISelectboxComponent.prototype._onClick = function () {
        this._createOverlay();
        this._overlayRef.attach(this._portal);
        this._subscribeToBackdrop();
        this._updatePosition();
    };
    UISelectboxComponent.prototype._onScroll = function () {
        this._updatePosition();
    };
    UISelectboxComponent.prototype._onResize = function () {
        this._updatePosition();
    };
    UISelectboxComponent.prototype._updatePosition = function () {
        if (!this._elementRef || !this._overlayRef)
            return;
        var elementBox = this._elementRef.nativeElement.getBoundingClientRect();
        this._overlayRef.overlayElement.style.left = elementBox.left + window.scrollX + 'px';
        this._overlayRef.overlayElement.style.top = (elementBox.bottom - 1) + window.scrollY + 'px';
        this._overlayRef.overlayElement.style.minWidth = (elementBox.right - elementBox.left) + 'px';
    };
    UISelectboxComponent.prototype._onSelect = function (selectedOption) {
        this.options.forEach(function (option) { return (option.selected = false); });
        selectedOption.selected = true;
        this.value = selectedOption.viewValue;
        this._onChange(selectedOption.value);
        this._onTouched();
        this._destroyOverlay();
    };
    UISelectboxComponent.prototype._setOptionByValue = function (value) {
        var _this = this;
        this.options.forEach(function (option) {
            if (option.value === value) {
                _this._onSelect(option);
            }
        });
    };
    UISelectboxComponent.prototype._createOverlay = function () {
        if (!this._overlayRef) {
            this._portal = new TemplatePortal(this.templateRef, this._viewContainerRef);
            this._overlayRef = this._overlay.create({ hasBackdrop: true });
        }
    };
    UISelectboxComponent.prototype._destroyOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
            this._overlayRef = null;
        }
    };
    UISelectboxComponent.prototype._subscribeToBackdrop = function () {
        var _this = this;
        this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
            _this._destroyOverlay();
        });
    };
    UISelectboxComponent.prototype._destroyOptions = function () {
        if (this._optionSubscription) {
            this._optionSubscription.unsubscribe();
            this._optionSubscription = null;
        }
    };
    UISelectboxComponent.prototype.writeValue = function (value) {
        if (this.options) {
            this._setOptionByValue(value);
        }
    };
    UISelectboxComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    UISelectboxComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    return UISelectboxComponent;
}());
export { UISelectboxComponent };
